import { ReactNode } from 'react';

import { Box, Container, Stack } from '@mui/material';
import Image from 'next/image';

import LocationBadge from './LocationBadge';
import styles from './MapSection.module.scss';

interface MapSectionProps {
  children?: ReactNode;
  hasLink?: boolean;
}

const MapSection = ({ children, hasLink = false }: MapSectionProps) => (
  <Container
    component="section"
    maxWidth={false}
    disableGutters
    classes={{ root: styles.root }}
    className={styles.container}
  >
    <Box className={styles.mapWrapper}>
      <Image src="/images/map.svg" alt="Map image" fill className={styles.mapImage} />
      <LocationBadge className={styles.locationBadge} hasLink={hasLink} />
    </Box>
    <Container maxWidth="xl" className={styles.contentContainer}>
      <Stack>{children}</Stack>
    </Container>
  </Container>
);

export default MapSection;
